import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-password-requirements',
  templateUrl: './password-requirements.component.html',
})
export class PasswordRequirementsComponent {
  @Input() passwordControl: AbstractControl | null = null;
  @Input() confirmControl: AbstractControl | null = null;

  get errors() {
    return this.passwordControl?.errors || {};
  }

  get touchedOrDirty(): boolean {
    if (!this.passwordControl) return false;
    return this.passwordControl.touched || this.passwordControl.dirty;
  }

  get passwordValid(): boolean {
    return !!this.passwordControl && this.passwordControl.valid;
  }

  get showMismatch(): boolean {
    return !!(
      this.confirmControl &&
      (this.confirmControl.touched || this.confirmControl.dirty) &&
      this.confirmControl.hasError('passwordMismatch')
    );
  }
}
